import jwt_decode from "jwt-decode";

(() => {
  if (!window.env) window.env = {};
  const urlParams = new URLSearchParams(window.location.search);
  const preview = urlParams.get("preview");

  if (window.token) {
    for (let tkey in window.token)
      if (window.token[tkey])
        window.token[tkey] = window.token[tkey].split("").reverse().join("");
    let tk = [window.token["f"], window.token["m"], window.token["l"]].join(
      "."
    );
    let decodedTK = jwt_decode(tk);
    window.env = decodedTK;
  }
  if (!window.env) window.env = {};
  for (const envKey in process.env) {
    // Preserve the explicit runtime false for this optional feature.
    if (envKey === "REACT_APP_SHOW_LOTTO_DREAM"
      ? window.env[envKey] === undefined || window.env[envKey] === null
      : !window.env[envKey]) window.env[envKey] = process.env[envKey];
  }
  if (preview == "true") {
    let preview_token = {
      f: urlParams.get("f"),
      m: urlParams.get("m"),
      l: urlParams.get("l"),
    };
    for (let tkey in preview_token)
      if (preview_token[tkey])
        preview_token[tkey] = preview_token[tkey].split("").reverse().join("");
    let tk = [preview_token["f"], preview_token["m"], preview_token["l"]].join(
      "."
    );
    let decodedPTK = jwt_decode(tk);
    Object.assign(window.env, decodedPTK);
  }
  window.env.modal_bg_header = `
  .modal_modal_bg>div>.modal-content>.modal-header{
    background: ${window.env.REACT_APP_BG_MODAL_HEADER};
    border: ${window.env.REACT_APP_BORDER_MODAL_HEADER};
  }
    .modal_modal_bg>div>.modal-content>.modal-body{
    background: ${window.env.REACT_APP_BG_MODAL_BODY};
  }
  .modal{
    padding-left: 0px !important;
  }
  `;

  window.env.custom_login = `
    .login_form_custom_gold {
      margin-top: 2rem;
      color: #fff;
    }
  
    .login_form_custom_gold input.error_validate {
      font-size: 12px;
      border: 1px solid #ff4d4d !important;
    }
  
    .login_form_custom_gold input[type="text"],
    .login_form_custom_gold input[type="password"] {
      width: 100%;
      padding: 0.75rem;
      margin-bottom: 1.5rem;
      border-radius: 8px;
      border: 1px solid #333;
      background-color: #fff;
      color: ${window.env.REACT_APP_TXT_COLOR_INPUT_LOGIN_REGISTER};
      font-size: 14px;
      transition: border 0.2s ease;
    }
  
    .login_form_custom_gold input[type="text"]:focus,
    .login_form_custom_gold input[type="password"]:focus {
      border: 1px solid ${window.env.REACT_APP_COLOR_BORDER_FOCUS};
      outline: none;
    }
  
    .login_form_custom_gold .password-wrapper {
      position: relative;
    }
  
    .login_form_custom_gold .password-wrapper .toggle-password {
      position: absolute;
      right: 10px;
      top: 35%;
      transform: translateY(-50%);
      background: none;
      border: none;
      color: #ffc000;
      font-size: 16px;
      cursor: pointer;
    }
  
    .login_form_custom_gold .forgot-password {
      text-align: right;
      margin: 0 0 1rem 0;
    }
  
    .login_form_custom_gold .forgot-password a {
      color: #ffc000;
      font-size: 14px;
      font-weight: 700;
      text-decoration: underline;
    }
  
    .login_form_custom_gold .forgot-password a:hover {
      text-decoration: none;
    }
  
    .login_form_custom_gold .login_button {
      position: relative;
      width: 100%;
      height: 44px;
      background: linear-gradient(#ffc000, #a36d00);
      border: none;
      border-radius: 10px;
      font-size: 16px;
      font-weight: 600;
      color: ${window.env.REACT_APP_TXT_COLOR_LOGIN_IN_MODAL};
      cursor: pointer;
      transition: background 0.3s ease;
    }
  
    .login_form_custom_gold .login_button:hover {
      background: linear-gradient(90deg, #ffc000, #ebcd9b);
    }
  
    .login_form_custom_gold .login_button .div_login_background {
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      width: 100%;
      height: 24px;
      top: 0;
      position: absolute;
      opacity: 0.2;
      background: #fff;
      left: 0;
    }
  
    .login_form_custom_gold .contact-support {
      text-align: center;
      margin-top: 2rem;
      font-size: 12px;
    }
  
    .login_form_custom_gold .contact-support a {
      color: ${window.env.REACT_APP_TXT_COLOR_CONTACT_REGISTER} !important;
      font-weight: 600;
      text-decoration: none;
    }
  
    .login_form_custom_gold .contact-support a:hover {
      text-decoration: underline;
    }
  `;
})();
